define('TescoMobile_Checkout/js/view/subscription-details/message-content',['uiComponent'], function (Component) {
  'use strict';

  const config = window.checkoutConfig.tescomobile.subscription_details;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/subscription-details/message-content',
      messageContent: config.message_content
    }
  });
});

